import merge from 'lodash/merge';
import * as STATUES from 'components/common/constants/reservationStatusConstants';
import { DEPARTURE, RETURN } from 'components/components/booking/utils/FlightConstants';
import TransHelper from 'components/common/translations/TransHelper';
import moment from 'moment';
import FlightHelper from 'components/common/helpers/FlightHelper';
import React from 'react';

export default class ReservationUIHelper {
  constructor(reservation, locale, setReservationToReview) {
    this.reservation = reservation;
    this.locale = locale;
    this.setReservationToReview = setReservationToReview;
    this.flightHelper = new FlightHelper(
      reservation.flight,
      locale,
      reservation.reservation_direction
    );
  }

  trans = (key, vars = null, prefix = 'content.bookingStatus') => {
    return TransHelper.translate(this.locale, prefix + "." + key, vars);
  }

  t = (key) => {
    return TransHelper.translate(this.locale, key);
  }

  isDeparture = () => {
    return this.reservation.flight_type === DEPARTURE;
  }

  getDate() {
    return moment(this.reservation.flight.flight_date).format("DD.MM.YYYY");
  }

  getPlaceFrom() {
    return this.flightHelper.getFrom();
  }

  getFlightTime(type) {
    if (type === this.reservation.flight.direction) {
      return this.flightHelper.getFlighTime();
    } else {
      return null;
    }
  }

  getAddress(type) {
    if (type === this.reservation.flight.direction) {
      return this.getAddressPhrase();
    } else {
      return null;
    }
  }

  slideShow = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setReservationToReview(this.reservation);
  }

  getPlaceTo() {
    return this.flightHelper.getTo();
  }

  getAddressPhrase() {
    return this.reservation.address_phrase;
  }

  canRateTrip() {
    return this.reservation.status === STATUES.STATUS_COMPLETED;
  }

  canSeeRate() {
    return this.reservation.status === STATUES.STATUS_COMPLETED_AND_REVIEWED;
  }

  parseNotificationDate = () => {
    var notifyDate = moment(this.reservation.notification_date);
    var now = moment();
    var tomorrow = moment().add(1, 'days');
    if (notifyDate.format("YYYY-M-D") === tomorrow.format("YYYY-M-D")) {
      return "tomorrow";
    } else if (notifyDate.format("YYYY-M-D") === now.format("YYYY-M-D")) {
      return "today";
    } else {
      return notifyDate.format("DD.MM.YY");
    }
  }

  getStatusInfo = () => {
    const status = this.reservation.status;
    const driverName = this.reservation.driver_name;
    const driverPhone = this.reservation.driver_phone;
    const paymentToDriver = this.reservation.payment_to_driver;
    const cancelledWithRefund = this.reservation.cancelled_with_refund;

    switch (status) {
      case STATUES.STATUS_NEW:
        return {
          icon: 'ellipsis-h',
          description: this.trans('statusNew.desc'),
          moreInfo: null,
          type: "pending",
          status: this.trans('statusNew.label'),
          tripIcon: ["fas", "shuttle-van"],
          isPositive: true,
        }
      case STATUES.STATUS_ACCEPT:
        if (this.isDeparture()) {
          var text = this.trans(
            'statusAccept.pickupTextDeparture',
            { "time": this.parseNotificationDate() }
          );
        } else {
          var text = this.trans('statusAccept.pickupText');
        }
        return {
          icon: 'check',
          description: this.trans('statusAccept.desc'),
          moreInfo: text,
          type: "success",
          status: this.trans('statusAccept.label'),
          tripIcon: ["fas", "shuttle-van"],
          isPositive: true,
        }
      case STATUES.STATUS_REJECT:
        return {
          icon: 'ban',
          description: this.trans('statusReject.desc'),
          moreInfo: (
            <span>
              {this.trans('statusReject.moreInfo')}{' '}
              <a href='mailto:info@pksoslo.com'>
                {this.trans('statusReject.contact')}
              </a>.
            </span>
          ),
          type: "alert",
          status: this.trans('statusReject.label'),
          tripIcon: ["fas", "times"],
          isPositive: false,
        }
      case STATUES.STATUS_CANCELED:
        var moreInfo = '';
        if (!paymentToDriver) {
          if (cancelledWithRefund) {
            moreInfo = this.trans('statusCanceled.moreInfo');
          } else {
            moreInfo = this.trans('statusCanceled.infoWithoutRefund');
          }
        }
        return {
          icon: 'times',
          description: this.trans('statusCanceled.desc'),
          moreInfo: moreInfo,
          type: "alert",
          status: this.trans('statusCanceled.label'),
          tripIcon: ["fas", "times"],
          isPositive: false,
        }
      case STATUES.STATUS_ASSIGNED:
        if (this.isDeparture()) {
          var pickupTime = moment(this.reservation.bus_arrival).format("HH:mm");
          var busArrivalDate = moment(this.reservation.bus_arrival).format("YYYY-M-D");
          var todayDate = moment().format("YYYY-M-D");
          if (busArrivalDate === todayDate) {
            var departureText = this.trans('statusAssigned.descTodayDeparture');
          } else {
            var departureText = this.trans('statusAssigned.descDeparture');
          }
          var text = (
            <span>
              <span style={{ 'display': 'block' }}>
                {driverName} {departureText} {pickupTime}
              </span>
              <span style={{ 'display': 'block' }}>
                {this.trans('statusAssigned.contactInfo')}{' '}
                <a href={`tel:${driverPhone}`}>{driverPhone}</a>
              </span>
            </span>
          );
        } else {
          var text = (
            <span>
              <span style={{ 'display': 'block' }}>
                {driverName} {this.trans('statusAssigned.descNormal')}
              </span>
              <span style={{ 'display': 'block' }}>
                {this.trans('statusAssigned.contactInfo')}{' '}
                <a href={`tel:${driverPhone}`}>{driverPhone}</a>
              </span>
            </span>
          );
        }
        return {
          icon: 'lock',
          description: this.trans('statusAssigned.desc'),
          moreInfo: text,
          type: "success",
          status: this.trans('statusAssigned.label'),
          tripIcon: ["fas", "shuttle-van"],
          isPositive: true,
        }
      case STATUES.STATUS_COMPLETED:
        return {
          icon: 'shuttle-van',
          description: this.trans('statusCompleted.allDone'),
          moreInfo: (
            <span>
              {this.trans('statusCompleted.desc')}{' '}
              <a href="" onClick={this.slideShow}>
                {this.t('content.bookingStatus.statusCompleted.review')}
              </a>.
            </span>
          ),
          type: "success",
          status: this.trans('statusCompleted.label'),
          tripIcon: ["fas", "shuttle-van"],
          isPositive: true,
          tripReviewLink: (
            <a href="" onClick={this.slideShow}>
              {this.t('content.bookingStatus.statusCompleted.tripReview')}
            </a>
          )
        }
      case STATUES.STATUS_COMPLETED_AND_REVIEWED:
        return {
          icon: 'shuttle-van',
          description: this.trans('statusCompleted.allDone'),
          moreInfo: this.trans('statusCompleted.thanksForReview'),
          type: "success",
          status: this.trans('statusCompleted.label'),
          tripIcon: ["fas", "shuttle-van"],
          isPositive: true,
        }
      case STATUES.STATUS_NO_SHOW:
        return {
          icon: 'frown',
          description: this.trans('statusNoShow.desc', { driver: driverName }),
          moreInfo: this.trans('statusNoShow.moreInfo'),
          type: "alert",
          status: this.trans('statusNoShow.label'),
          tripIcon: ["far", "frown"],
          isPositive: false,
        }
    }
  }

}